import {AccessTime, Check, HelpOutline, SvgIconComponent} from '@mui/icons-material'
import {hpTheme} from '@hconnect/uikit/src/lib2'
import React from 'react'

import {DeliveryStatus} from '../types'

const {palette} = hpTheme

export const deliveryStatusToIconMap: Record<DeliveryStatus, SvgIconComponent> = {
  [DeliveryStatus.Delivered]: Check,
  [DeliveryStatus.Overdue]: AccessTime,
  [DeliveryStatus.Unknown]: HelpOutline
}

const deliveryStatusToStyleMap: Record<DeliveryStatus, {color: string}> = {
  [DeliveryStatus.Delivered]: {color: palette.common.white},
  [DeliveryStatus.Overdue]: {color: palette.common.white},
  [DeliveryStatus.Unknown]: {color: palette.text.primarySoft}
}

interface DeliveryStatusIconProps {
  status: DeliveryStatus
}

export const DeliveryStatusBarIcon: React.FC<DeliveryStatusIconProps> = ({status}) => {
  const Icon = deliveryStatusToIconMap[status]
  return React.createElement(Icon, {sx: deliveryStatusToStyleMap[status]})
}
